import React, { useMemo } from 'react';
import { Skeleton } from '@mui/material';
import { filter, sortBy } from 'lodash';
import CommonPieChart from './CommonPieChart';
import { formatNumber } from '../utils/util';


const GRADE_LEVEL_LABELS = {
  'group-k5': 'K-5',
  'group-68': '6-8',
  'group-912': '9-12',
  'group-highed': 'Higher Education',
  'group-gov': 'Government',
};


export default function GradeLevelDemographics({ demographics }) {
  const dataset = useMemo(() => {
    if (!Array.isArray(demographics)) return [];
    const nonZero = filter(demographics, (item) => item.gradePercentageInt > 0);
    const mapped = nonZero.map((item) => ({
      id: item.gradeLevel,
      label: GRADE_LEVEL_LABELS[item.gradeLevel] || item.gradeLevel,
      value: item.gradePercentageInt,
    }));
    return sortBy(mapped, 'value').reverse();
  }, [demographics]);


  if (!demographics) {
    return <Skeleton variant="circular" width="15vw" height="15vw" />;
  }
  return (
    <CommonPieChart
      title="Grade Level Demographics"
      data={dataset}
      height={340}
      minHeight="40vh"
      maxHeight="70vh"
      description="Breakdown of your audience by educational level, showing which grade groups engage most with your content."
      valueFormatter={(v) => `${v.value}%`}
      margin={{ left: 0, top: 10, right: 0, bottom: 3.5 * 28.6 }}


    />
  );
}
